import { CONTROL_STYLE_OPTIONS } from '@/pages/Onboarding/options/ControlStyle/CONTROL_STYLE_OPTIONS.ts';
import { ControlStyleOptionIdType } from '@/pages/Onboarding/options/ControlStyle/types.ts';

const DEFAULT_ID: ControlStyleOptionIdType = 'cold_and_cruel';
const DEFAULT_TITLE = CONTROL_STYLE_OPTIONS[0].title;

export const getControlStyleIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): ControlStyleOptionIdType | null => {
  const id = CONTROL_STYLE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getControlStyleTitleById = (
  id: ControlStyleOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = CONTROL_STYLE_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
